// extracted by mini-css-extract-plugin
export default {"new_countrycode_field":"popups_new_countrycode_field__+xDRZ","new_countrycode_err":"popups_new_countrycode_err__W0NOK","err_text":"popups_err_text__uxUpV"};